import React, { memo } from "react";

import type { TypeAvatarProps } from "./AvatarTypes";
import AvatarHybrid from "./AvatarHybrid";

/**
 * Avatar component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props, BORDER-mixin props, or a styled() extension).
 */
export const Avatar = React.forwardRef<HTMLDivElement, TypeAvatarProps>(
  (props, ref) => <AvatarHybrid {...props} ref={ref} />
);

Avatar.displayName = "Avatar";

// Keep deep-import compatibility: getAvatarColor was previously exported here.
export { getAvatarColor } from "./utils";

export default memo(Avatar);
